import React from 'react';

const FormSuccess = ({ children }) => {
	return <>{children}</>;
};

export default FormSuccess;
